import React from "react";
import Success from "../Success";
import Warning from "../Warning";

export default ({ type = "warning", children }) => {
  const backgroundColourClassName = "bg-default";

  if (type === "success") {
    return (
      <Success content={children} backgroundColourClassName="bg-default" />
    );
  }

  return <Warning content={children} backgroundColourClassName="bg-default" />;
};
